import type { ReactNode } from "react";

export type BadgeTone =
  | "critical"
  | "disabled"
  | "global"
  | "info"
  | "neutral"
  | "pending"
  | "recommended"
  | "success"
  | "warning";

type BadgeProps = {
  readonly children: ReactNode;
  readonly className?: string;
  readonly dot?: boolean;
  readonly tone?: BadgeTone;
};

const toneClasses = {
  critical: "border-critical bg-red-50 text-critical",
  disabled: "border-disabled bg-gray-50 text-disabled",
  global: "border-global-border bg-global-bg text-global-text",
  info: "border-info bg-blue-50 text-info",
  neutral: "border-neutral bg-gray-50 text-neutral",
  pending: "border-pending bg-row-warning text-pending",
  recommended: "border-cta bg-row-warning text-cta",
  success: "border-success bg-emerald-50 text-success",
  warning: "border-warning bg-row-warning text-warning",
} as const satisfies Record<BadgeTone, string>;

export function Badge({
  children,
  className = "",
  dot = false,
  tone = "neutral",
}: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded border px-2 py-0.5 text-[11px] font-medium ${toneClasses[tone]} ${className}`}
    >
      {dot ? (
        <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-current" />
      ) : null}
      {children}
    </span>
  );
}
